import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "downloadRemove",
  "use": "downloadRemove-usage",
  "viewBox": "0 0 245.4 246.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 245.4 246.1\" id=\"downloadRemove\"><style></style><circle cx=\"122.4\" cy=\"123.5\" r=\"121.7\" fill=\"none\" /><path class=\"st2\" d=\"M166.3 123.5c0 3.6-2.9 6.5-6.5 6.5H85c-3.6 0-6.5-2.9-6.5-6.5s2.9-6.5 6.5-6.5h74.8c3.5 0 6.5 2.9 6.5 6.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol